import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { styled } from "@mui/material/styles";
// import { getDroplistTrafficReports, setLoading } from "store/actions/reportActions";
// import { useDispatch } from "react-redux";

const CountryReportPicker = ({
  setFieldValue,
  handleChange = () => {},
  trafficByCountryPage = true,
  countries,
  loading = false,
  country = {},
}) => {
  const SelectF = styled(Select)(() => ({
    width: "100%",
    fontSize: "15px",
  }));
  const getOptionStyle = (base) => ({
    ...base,
    fontSize: "15px",
  });
  //   const dispatch = useDispatch();

  //   useEffect(() => {
  //     dispatch(setLoading());
  //     dispatch(getDroplistTrafficReports());
  //     // eslint-disable-next-line
  //   }, []);
  return (
    <div>
      <SelectF
        onMenuOpen={document.body}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        closeMenuOnScroll={(e) => !e.target?.classList?.contains("select__menu-list")}
        className="basic-single"
        classNamePrefix="select"
        value={country?.name ? country : null}
        isLoading={loading}
        // isDisabled={isDisabled}
        isClearable
        onChange={(option) => {
          handleChange(option);

          if (country) setFieldValue("country", option || "");
          else {
            setFieldValue("country", option || "");
          }
        }}
        isSearchable
        getOptionValue={(option) => `${option.value}`}
        getOptionLabel={(option) => `${option.name}`}
        name="country"
        id="country"
        options={countries}
        placeholder={trafficByCountryPage ? "Select a Country" : "All"}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), option: getOptionStyle }}
      />
    </div>
  );
};

CountryReportPicker.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  countries: PropTypes.instanceOf(Array).isRequired,
  loading: PropTypes.bool,
  trafficByCountryPage: PropTypes.bool,
  country: PropTypes.instanceOf(Object),
};

export default CountryReportPicker;
